<template>
  <main class="container mx-auto mt-16 mb-10">
    <UtilsDetailTitleLoading v-if="isLoading" />
    <ArticleDetailTitle
      v-else
      text-to="Articles"
      url="/ideas"
      :detail-data="contentsData.attributes"
      :is-ideas-article="true"
    />

    <UtilsDetailContentLoading v-if="isLoading" :is-case-study="false" />
    <ArticleDetailContent
      v-else
      :detail-data="contentsData.attributes"
      :is-ideas-article="true"
    />

    <ArticleDetailRelatedArticles
      :detail-id="contentsData.id"
      :industries="contentsData.attributes?.article_industries?.data"
      :expertises="contentsData.attributes?.expertices?.data"
    />
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo
const mainBanner = global.mainBanner

const route = useRoute()

const isLoading = ref(true)
const contentsData = ref([])

const getContents = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/contents/${route.params.slug}`,
    {
      query: {
        populate:
          'image,layout_component,layout_component.type,expertices.expertice_category,article_industries,seo.image',
        'filters[$and][0][layout][$eq]': 'article'
      }
    }
  )
  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Article does not exist`
    })
  }

  return data.value
}

const contents = await getContents()
contentsData.value = contents.data

const currentLink = computed(() => {
  return window?.location?.href || ''
})

const seoData = {
  title:
    contentsData.value?.attributes?.seo?.seo_title + ' | Suitmedia' ||
    'Suitmedia',
  description:
    contentsData.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    contentsData.value?.attributes?.seo?.image.data?.attributes?.url ||
    contentsData?.value?.attributes?.image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
}

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Article',
  name: seoData.title,
  url: currentLink.value,
  description: seoData.description,
  image: seoData.image,
  datePublished: contentsData.value?.attributes?.publish_at,
  author: contentsData.value?.attributes?.layout_component?.[0]?.author,
  publisher: {
    '@type': 'Organization',
    name: 'Suitmedia',
    logo: {
      '@type': 'ImageObject',
      url: '/assets/img/site-logo.png'
    }
  },
  headline: contentsData.value?.attributes?.title
})
useSeoMeta({
  title: seoData.title,
  ogTitle: seoData.title,
  description: seoData.description,
  ogDescription: seoData.description,
  ogImage: seoData.image,
  ogType: contentsData.value?.attributes?.seo?.open_graph_type,
  twitterTitle: seoData.title,
  twitterDescription: seoData.description,
  twitterImage: seoData.image
})
</script>

<style lang="scss" scoped></style>
